import styled from '@emotion/styled';

const AlignCenter = styled.div(`
    text-align: center;
`);

export default AlignCenter;
